import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-10 mb-10 result-block xl:mt-24" }
const _hoisted_2 = { class: `font-raleway text-white text-2xl` }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: `bg-${_ctx.answer.colour} result-circle`
    }, [
      _createVNode("i", {
        class: ` result-icon text-brand-darkBlue fas fa-${_ctx.answer.icon}`
      }, null, 2)
    ], 2),
    _createVNode("div", null, [
      _createVNode("p", {
        class: 
          `font-raleway leading-none font-bold text-${_ctx.answer.colour} text-5xl xl:text-6xl my-3`
        
      }, _toDisplayString(_ctx.resultText), 3),
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.getSubtitle(_ctx.stat, _ctx.answer.text, _ctx.total)), 1)
    ])
  ]))
}